/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CalculateWorkingTimeCostData } from './CalculateWorkingTimeCostData';
import {
    CalculateWorkingTimeCostDataFromJSON,
    CalculateWorkingTimeCostDataFromJSONTyped,
    CalculateWorkingTimeCostDataToJSON,
    CalculateWorkingTimeCostDataToJSONTyped,
} from './CalculateWorkingTimeCostData';

/**
 * 
 * @export
 * @interface BulkCalculateWorkingTimeCostData
 */
export interface BulkCalculateWorkingTimeCostData {
    /**
     * 
     * @type {Array<CalculateWorkingTimeCostData>}
     * @memberof BulkCalculateWorkingTimeCostData
     */
    bulkCalculateWorkingTimeCostData: Array<CalculateWorkingTimeCostData>;
}

/**
 * Check if a given object implements the BulkCalculateWorkingTimeCostData interface.
 */
export function instanceOfBulkCalculateWorkingTimeCostData(value: object): value is BulkCalculateWorkingTimeCostData {
    if (!('bulkCalculateWorkingTimeCostData' in value) || value['bulkCalculateWorkingTimeCostData'] === undefined) return false;
    return true;
}

export function BulkCalculateWorkingTimeCostDataFromJSON(json: any): BulkCalculateWorkingTimeCostData {
    return BulkCalculateWorkingTimeCostDataFromJSONTyped(json, false);
}

export function BulkCalculateWorkingTimeCostDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkCalculateWorkingTimeCostData {
    if (json == null) {
        return json;
    }
    return {
        
        'bulkCalculateWorkingTimeCostData': ((json['bulkCalculateWorkingTimeCostData'] as Array<any>).map(CalculateWorkingTimeCostDataFromJSON)),
    };
}

  export function BulkCalculateWorkingTimeCostDataToJSON(json: any): BulkCalculateWorkingTimeCostData {
      return BulkCalculateWorkingTimeCostDataToJSONTyped(json, false);
  }

  export function BulkCalculateWorkingTimeCostDataToJSONTyped(value?: BulkCalculateWorkingTimeCostData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bulkCalculateWorkingTimeCostData': ((value['bulkCalculateWorkingTimeCostData'] as Array<any>).map(CalculateWorkingTimeCostDataToJSON)),
    };
}

